import { TrackingEvent } from '../types';

// Please update `./README.md` when changing the tracking configuration!

export function clickedEmailAdress(adress: string): TrackingEvent[] {
    return [{
        category: 'contact',
        action: 'click - email',
        name: adress,
    }];
}
